const normalizePathOrUrl = (value: string): string => {
  const trimmed = String(value || '').trim();
  if (!trimmed || trimmed === '/') {
    return '';
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/\/+$/, '');
  }

  return `/${trimmed.replace(/^\/+|\/+$/g, '')}`;
};

const normalizePokerApiBaseUrl = (value: string): string => {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }

  return trimmed.replace(/^ws/i, 'http').replace(/\/+$/, '');
};

const joinBaseAndPath = (base: string, path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalizedPath}` : normalizedPath;
};

export const APP_BASE_PATH = normalizePathOrUrl(process.env.BASE_PATH || '');
export const HOLDEM_BACKEND_BASE_URL = normalizePathOrUrl(
  process.env.HOLDEM_BACKEND_URL || process.env.BASE_PATH || '',
);
export const POKER_API_BASE_URL = normalizePokerApiBaseUrl(process.env.POKER_SERVER_URL || '');

export const buildHoldemBackendUrl = (path: string): string => joinBaseAndPath(HOLDEM_BACKEND_BASE_URL, path);
export const buildAppPath = (path: string): string => joinBaseAndPath(APP_BASE_PATH, path);
